import { DevicePlatform } from 'src/utils/devicePlatform';

const StoreDownloads = ({ platform }: { platform: DevicePlatform }): JSX.Element => {
  const googlePlay = (
    <a className="store-button" data-recommended={platform === 'android'} href="https://play.google.com/store/apps/details?id=com.ilrd.messenger" target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
          <path fill="#00D7FE" d="M4 3v26l14-13z" />
          <path fill="#00F076" d="M4 3l18 10-4 3z" />
          <path fill="#FFCE00" d="m22 13 6 3-6 3-4-3z" />
          <path fill="#FF3A44" d="m4 29 18-10-4-3z" />
        </svg>
        <span><small>GET IT ON</small>{' '}<strong>Google Play</strong></span>
      </a>
  );
  const appStore = (
    <a className="store-button" data-recommended={platform === 'ios'} href="https://apps.apple.com/il/app/werxpaces/id6743986905?l=he" target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
          <rect width="32" height="32" rx="7" fill="#1686F8" />
          <path d="m12 7 12 20M20 7 9 26M6 21h20" fill="none" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" />
        </svg>
        <span><small>Download on the</small>{' '}<strong>App Store</strong></span>
      </a>
  );

  return (
  <div id="mobile" className="mobile-stores rv" aria-labelledby="mobile-heading">
    <h3 id="mobile-heading">Mobile</h3>
    <p>Get WerxPace on your Android phone or iPhone.</p>
    {(platform === 'android' || platform === 'ios') && (
      <p className="mobile-recommendation">Recommended for your device: {platform === 'ios' ? 'App Store' : 'Google Play'}</p>
    )}
    <div className="store-buttons">
      {platform === 'ios' ? <>{appStore}{googlePlay}</> : <>{googlePlay}{appStore}</>}

    </div>
  </div>
  );
};

export default StoreDownloads;
